// @ts-ignore - clack is ESM and TS complains about that. It works though
import clack from '@clack/prompts';

export default clack;
